import React from 'react';

export default function BuildiveLogo({ size = 28, showText = true, className = '' }) {
  return (
    <div 
      className={`buildive-brand-logo ${className}`} 
      style={{ display: 'inline-flex', alignItems: 'center', gap: '10px', textDecoration: 'none' }}
    >
      <div 
        style={{
          width: size,
          height: size,
          borderRadius: Math.round(size * 0.25),
          background: 'var(--text-primary)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        {/* Geometric Buildive Mark */}
        <svg 
          width={Math.round(size * 0.62)} 
          height={Math.round(size * 0.62)} 
          viewBox="0 0 100 100" 
          fill="none" 
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* Top-Right Arrow/Polygon */}
          <path 
            d="M20 20 H75 C80 20 84 24 84 29 V50 L56 50 L70 36 L44 36 L20 60 Z" 
            fill="var(--bg-base)" 
          />
          {/* Bottom-Left Arrow/Polygon */}
          <path 
            d="M80 80 H25 C20 80 16 76 16 71 V50 L44 50 L30 64 L56 64 L80 40 Z" 
            fill="var(--bg-base)" 
          />
        </svg>
      </div>

      {showText && (
        <span 
          style={{ 
            fontFamily: "'Sora', 'Plus Jakarta Sans', sans-serif", 
            fontWeight: 800, 
            fontSize: `${Math.round(size * 0.68)}px`, 
            letterSpacing: '-0.03em',
            color: 'var(--text-primary)',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '2px'
          }}
        >
          Buildive
        </span>
      )}
    </div>
  );
}
